<template>
  <Modal
    class="tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]"
    :visible="showRef"
    border-radius="4px"
    @close="handleCloseModal(true)"
  >
    <ModalHeader
      style="position: sticky; top: 0; z-index: 10; background: white"
      :class="`modal-header`"
      :title="
        getComponentUiText(
          'app-assess-assessment-modal-create-update-template-title-1',
        )
      "
      @close="handleCloseModal"
    />
    <div
      class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-self-stretch md:tw-p-[40px] tw-p-[20px] tw-bg-[#FFFFFF]"
    >
      <div
        class="tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper tw-pb-[40px]"
      >
        <span
          class="tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]"
          >{{
            getComponentUiText(
              "app-assess-assessment-history-create-or-update-assessment-template-1",
            )
          }}</span
        >
        <span
          class="tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
          >{{
            getComponentUiText(
              "app-assess-assessment-modal-create-update-template-sub-title-1",
            )
          }}</span
        >
      </div>
      <div
        class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[20px] md:tw-px-[25px] tw-px-[10px] tw-py-[25px] main"
      >
        <span
          class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%]"
          >{{
            getComponentUiText(
              "app-assess-assessment-modal-create-update-template-create-new-template-1",
            )
          }}</span
        >
        <div
          class="tw-flex md:tw-items-center tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded"
        >
          <div class="left">
            <div
              class="tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info"
            >
              <span
                class="tw-text-[#231f20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[100%]"
                >{{
                  getComponentUiText(
                    "app-assess-assessment-modal-create-update-template-name-1",
                  )
                }}</span
              >
            </div>
          </div>
          <div
            class="tw-flex tw-flex-col tw-items-start tw-gap-5 tw-overflow-auto right tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full"
          >
            <input
              v-model="modal.templateName"
              data-cy="create-and-upate-assessment-template-name"
              :placeholder="
                getComponentUiText(
                  'app-assess-assessment-modal-create-update-placeholder-input-1',
                )
              "
              :class="`input-custom tw-rounded-[6px]  tw-text-[13px] tw-h-[56px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-px-5 tw-py-[18px] tw-bg-[#FFFFFF]  ${
                isCreateAssessment
                  ? 'tw-text-[#231F20]tw-bg-[#FFFFFF]'
                  : 'tw-text-[#878787] tw-bg-[#e9eaed]'
              }`"
              @focus="handleFocusInInput"
            />
          </div>
        </div>
        <div
          class="tw-flex tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded"
        >
          <div class="left">
            <div
              class="tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info tw-py-[9px]"
            >
              <span
                class="tw-text-[#231f20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[100%]"
                >{{
                  getComponentUiText(
                    "app-menu-submenu-home-setup-wizard-description-title-1",
                  )
                }}</span
              >
            </div>
          </div>
          <div
            class="tw-flex tw-flex-col tw-items-start tw-overflow-auto right tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full"
          >
            <textarea
              v-model="modal.templateDescription"
              :placeholder="
                getComponentUiText(
                  'app-assess-assessment-modal-create-update-description-placeholder-1',
                )
              "
              :class="`input-custom tw-outline-0 tw-rounded-[6px] tw-text-[13px]  tw-h-[122px] tw-gap-36 tw-self-stretch tw-p-5 tw-py-[18px] ${
                isCreateAssessment
                  ? 'tw-text-[#231F20]tw-bg-[#FFFFFF]'
                  : 'tw-text-[#878787] tw-bg-[#e9eaed]'
              }`"
              @focus="handleFocusInInput"
            />
          </div>
        </div>
        <div
          class="tw-flex md:tw-items-center tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded"
        >
          <div class="left">
            <div
              class="tw-flex tw-w-[260px] tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info"
            >
              <span
                class="tw-text-[#231f20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[100%]"
                >{{
                  getComponentUiText(
                    "app-assess-assessment-modal-create-update-version-1",
                  )
                }}</span
              >
            </div>
          </div>
          <div
            class="tw-flex tw-flex-col tw-items-start tw-gap-5 tw-overflow-auto right tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full"
          >
            <input
              v-model="modal.templateVersion"
              :placeholder="
                getComponentUiText(
                  'app-assess-assessment-modal-create-update-version-placeholder-1',
                )
              "
              :class="`input-custom tw-h-[56px] ${
                isCreateAssessment
                  ? 'tw-text-[#231F20]tw-bg-[#FFFFFF]'
                  : 'tw-text-[#878787] tw-bg-[#e9eaed]'
              } tw-rounded-[6px]  tw-text-[13px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-px-5 tw-py-[18px]`"
              @focus="handleFocusInInput"
            />
          </div>
        </div>
      </div>
      <div
        class="tw-flex tw-justify-start tw-items-start tw-py-[25px] tw-self-stretch tw-px-5 tw-text-[#878787] tw-text-[12px] tw-not-italic tw-font-[600] tw-leading-[100%] tw-tracking-[1.2px] tw-uppercase"
      >
        <div>
          {{
            getComponentUiText(
              "app-component-assessment-create-assessment-modal-select-existing-assessment-divider-or-1",
            )
          }}
        </div>
      </div>
      <div
        class="tw-flex tw-px-[25px] tw-mb-[40px] tw-py-[25px] tw-flex-col md:tw-flex-row tw-justify-between md:tw-items-center tw-gap-[20px] md:tw-gap-[10px] tw-self-stretch tw-rounded-[4px] main"
      >
        <span
          class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[100%] tw-min-w-[260px]"
          >{{
            getComponentUiText(
              "app-assess-assessment-modal-create-update-existing-template-1",
            )
          }}</span
        >
        <!-- Template DROPDOWN start -->
        <div
          class="tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[541px]"
        >
          <div
            class="tw-cursor-pointer tw-rounded-[6px] tw-flex tw-items-center tw-justify-between tw-gap-36 tw-self-stretch tw-p-5 tw-bg-[#FFFFFF] tw-max-w-[100%] md:tw-max-w-[541px] tw-w-full"
            @click="isTemplateDropdownOpen = !isTemplateDropdownOpen"
          >
            <span
              :class="`${
                templateSelected ? 'tw-text-[#211F58]' : 'tw-text-[#B7B7B7]'
              } tw-text-[13px] tw-not-italic tw-leading-[100%]`"
              >{{
                templateSelected
                  ? templateSelected?.templateName
                  : getComponentUiText(
                      "app-component-assessment-create-assessment-modal-template-dropdown-placeholder-1",
                    )
              }}</span
            >
            <span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
              >
                <path
                  d="M11.8741 2.10715L6.38429 8.33065C6.33485 8.3829 6.27527 8.42453 6.2092 8.45297C6.14312 8.48142 6.07194 8.49609 6 8.49609C5.92806 8.49609 5.85688 8.48142 5.7908 8.45297C5.72473 8.42453 5.66515 8.3829 5.61571 8.33065L0.125859 2.10715C0.081969 2.05772 0.0483386 2.00005 0.02692 1.93751C0.00550146 1.87497 -0.00327902 1.80879 0.00108975 1.74283C0.0065009 1.67633 0.0251891 1.6116 0.056049 1.55245C0.086909 1.4933 0.129313 1.44094 0.180757 1.39846L1.10405 0.624894C1.15449 0.581267 1.21315 0.548191 1.27658 0.527618C1.34002 0.507046 1.40693 0.499394 1.47337 0.505115C1.53949 0.509899 1.604 0.52781 1.66313 0.557801C1.72225 0.587792 1.77481 0.629263 1.81773 0.679792L5.91516 5.39607C5.94039 5.42106 5.97447 5.43508 6.00998 5.43508C6.04549 5.43508 6.07957 5.42106 6.10481 5.39607L10.1823 0.679792C10.2629 0.583426 10.377 0.521046 10.5017 0.505115C10.5678 0.498714 10.6345 0.50557 10.6979 0.525281C10.7613 0.544992 10.8202 0.57716 10.871 0.619902L11.8192 1.39846C11.8707 1.44094 11.9131 1.4933 11.9439 1.55245C11.9748 1.6116 11.9935 1.67633 11.9989 1.74283C12.0033 1.80879 11.9945 1.87497 11.9731 1.93751C11.9517 2.00005 11.918 2.05771 11.8741 2.10715Z"
                  fill="#387DFF"
                />
              </svg>
            </span>
          </div>
          <div
            :class="`tw-w-full tw-flex tw-flex-col tw-items-start tw-self-stretch tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-overflow-auto tw-max-h-40 templateAssessmentWrapper ${
              isTemplateDropdownOpen ? '' : 'close'
            }`"
          >
            <span
              v-for="(template, index) in listTemplate"
              :key="`${template.templateId}-${index}`"
              class="tw-cursor-pointer tw-overflow-hidden tw-flex tw-items-center tw-gap-[15px] tw-self-stretch tw-px-[24px] tw-py-[18px] templateDropdownItem"
              @click="
                () => {
                  templateSelected = template;
                  isTemplateDropdownOpen = false;
                  isCreateAssessment = false;
                }
              "
              >{{ template.templateName }}</span
            >
          </div>
        </div>
        <!-- Template DROPDOWN end -->
      </div>
      <ButtonLoading
        :title="
          getComponentUiText(
            !templateSelected
              ? 'app-component-assessment-create-assessment-modal-create-assessment-btn-1'
              : 'app-component-assessment-create-assessment-modal-update-assessment-btn-1',
          )
        "
        :disabled="isDisable"
        :is-loading="isLoading"
        @click-action="createOrUpdateAssessment"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch, reactive, computed } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import ButtonLoading from "@/components/common/buttonLoading.vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  checklistId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:show", "resetModalHistory"]);

const modal = reactive({
  templateName: "",
  templateVersion: "",
  templateDescription: "",
});

const listTemplate = computed(() => store.state.Assessment.listTemplate);

const isLoading = ref(false);

const isDisable = ref(true);
const isCreateAssessment = ref(true);
const showRef = ref(props.show);
const notInfoVisible = ref(true);
const isTemplateDropdownOpen = ref(false);
const templateSelected = ref<(typeof listTemplate.value)[number] | null>(null);
const isModalValue = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

watch(
  () => [modal.templateName, templateSelected.value],
  () => {
    isDisable.value = !(modal.templateName || templateSelected.value);
  },
);

const handleFocusInInput = () => {
  isCreateAssessment.value = true;
  templateSelected.value = null;
};

const handleCloseModal = (fromModal = false) => {
  if (
    modal.templateName ||
    modal.templateVersion ||
    modal.templateDescription ||
    templateSelected.value?.templateId
  ) {
    isModalValue.value = true;
  }
  if (fromModal && isModalValue.value) return;

  showRef.value = false;
  modal.templateName = "";
  modal.templateVersion = "";
  modal.templateDescription = "";
  templateSelected.value = null;
  isModalValue.value = false;
  emit("update:show", showRef.value);
};

const createOrUpdateAssessment = async () => {
  isLoading.value = true;
  const isSuccess = await store.dispatch(
    "Assessment/createOrUpdateAssessmentTemplate",
    {
      checklistId: props.checklistId,
      templateId: templateSelected.value?.templateId,
      data: modal,
    },
  );
  if (isSuccess) {
    handleCloseModal();
  }
  isLoading.value = false;
};
</script>

<style lang="scss" scoped>
.main {
  border: 1px solid #eff0f1;
  background: rgba(239, 240, 241, 0.5);
  transition: all 0.3s ease-in-out;
}

.templateAssessmentWrapper {
  transition: all 0.3s ease-in-out;
  border: 1px solid #eff0f1;
  background: #ffffff;
}

.templateAssessmentWrapper .templateDropdownItem {
  transition: all 0.3s ease-in-out;
  color: #231f20;
  font-size: 13px;
  font-weight: 400;
  min-height: 50px;
}

.templateAssessmentWrapper .templateDropdownItem:hover {
  background: #f2f8ff;
}

.templateAssessmentWrapper .templateDropdownItem:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.close {
  height: 0;
  padding: 0;
  overflow: hidden;
  filter: blur(1px);
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
::placeholder {
  color: var(--UI-dark-grey, #878787);
  /* text/text-13_reg */
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.input-custom {
  border: 1px solid var(--UI-rule, #eff0f1);
  &::placeholder {
    color: #b7b7b7;
  }
}
</style>
